export enum Role {
  GUEST = 'Guest',
  USER = 'User',
};
